const StoriesSortType = Object.freeze({
  SORT_BY_NEWEST: 'Sort by Newest',
  SORT_BY_OLDEST: 'Sort by Oldest',
});

export default StoriesSortType;
